import { makeStyles, createStyles } from "@mui/styles";
const lineHeight = 10;
const fontSize = 10;
const numberLines = 2;
export const useDefaultStyles = makeStyles(({ palette: { text, grey } }) => createStyles({
    fadedEllipsesFont: {
        fontSize: `${fontSize}px`,
        lineHeight: `${lineHeight}px`,
    },
    fadedEllipses: {
        overflow: "hidden",
        lineHeight: `${lineHeight}px`,
        height: `${lineHeight * numberLines}px`,
        //${MEAL_OPTION_NOTE_HEIGHT}in`,
        display: "block",
        "&:before": {
            content: '""',
            float: "left",
            width: "5px",
            height: `${lineHeight * numberLines}px`,
        },
        "& > *:first-child": {
            float: "right",
            width: "100%",
            marginLeft: "-5px",
        },
        "&:after": {
            color: grey[300],
            content: '"\u2026"',
            float: "right",
            position: "relative",
            top: `-${lineHeight + 1}px`, //This offset looks better ( + 1 px)
            left: "100%",
            width: "4em", // Width & marginLeft control the width of the fade block of text
            marginLeft: "-4em",
            paddingRight: "5px",
            textAlign: "right",
            background: "linear-gradient(to right, rgba(255, 255, 255, 0), white 70%, white)",
            fallbacks: {
                background: "white",
            },
        },
    },
    fadedEllipsesContainer: {
        width: "100%",
    },
}));
//# sourceMappingURL=index.js.map